<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="mb-6">
            <label for="switch-horario-activo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('clients.horario_descarga_activo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-horario-activo"
              :aria-label="$t('clients.horario_descarga_activo')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.activo" 
              :active-text="$t('companies.active')"/>
          </div>

          <div class="mb-6">
            <label class="text-sm font-semibold text-secondary-600 block mb-4">{{$t('clients.horario_descarga_dias')}}</label>
            <div>
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-lunes" class="sr-only">
                    {{$t('days.monday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-lunes"
                    :aria-label="$t('days.monday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.lunes.activo" 
                    :active-text="$t('days.monday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.lunes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.lunes.activo 
                      ? form.lunes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.lunes.activo}"
                      :disabled="!form.lunes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.lunes.range"
                      :placeholder="form.lunes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.lunes.range"
                    aria-label="Limpiar hora máxima del lunes"
                    @clear="form.lunes.range = null"
                  />
                </el-form-item>
              </div>

              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-martes" class="sr-only">
                    {{$t('days.tuesday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-martes"
                    :aria-label="$t('days.tuesday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.martes.activo" 
                    :active-text="$t('days.tuesday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.martes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.martes.activo 
                      ? form.martes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.martes.activo}"
                      :disabled="!form.martes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.martes.range"
                      :placeholder="form.martes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.martes.range"
                    aria-label="Limpiar hora máxima del martes"
                    @clear="form.martes.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-miercoles" class="sr-only">
                    {{$t('days.wednesday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-miercoles"
                    :aria-label="$t('days.wednesday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.miercoles.activo" 
                    :active-text="$t('days.wednesday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.miercoles.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.miercoles.activo 
                      ? form.miercoles.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.miercoles.activo}"
                      :disabled="!form.miercoles.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.miercoles.range"
                      :placeholder="form.miercoles.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.miercoles.range"
                    aria-label="Limpiar hora máxima del miercoles"
                    @clear="form.miercoles.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-jueves" class="sr-only">
                    {{$t('days.thursday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-jueves"
                    :aria-label="$t('days.thursday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.jueves.activo" 
                    :active-text="$t('days.thursday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.jueves.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.jueves.activo 
                      ? form.jueves.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.jueves.activo}"
                      :disabled="!form.jueves.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.jueves.range"
                      :placeholder="form.jueves.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.jueves.range"
                    aria-label="Limpiar hora máxima del jueves"
                    @clear="form.jueves.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-viernes" class="sr-only">
                    {{$t('days.friday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-viernes"
                    :aria-label="$t('days.friday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.viernes.activo" 
                    :active-text="$t('days.friday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.viernes.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.viernes.activo 
                      ? form.viernes.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.viernes.activo}"
                      :disabled="!form.viernes.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.viernes.range"
                      :placeholder="form.viernes.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.viernes.range"
                    aria-label="Limpiar hora máxima del viernes"
                    @clear="form.viernes.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-sabado" class="sr-only">
                    {{$t('days.saturday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-sabado"
                    :aria-label="$t('days.saturday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.sabado.activo" 
                    :active-text="$t('days.saturday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.sabado.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.sabado.activo 
                      ? form.sabado.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.sabado.activo}"
                      :disabled="!form.sabado.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.sabado.range"
                      :placeholder="form.sabado.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.sabado.range"
                    aria-label="Limpiar hora máxima del sabado"
                    @clear="form.sabado.range = null"
                  />
                </el-form-item>
              </div>
              
              <div class="flex flex-col md:flex-row items-start md:items-center mb-2 gap-x-6">
                <div class="flex flex-row items-center gap-x-6 mb-2 md:mb-0">
                  <label for="switch-domingo" class="sr-only">
                    {{$t('days.sunday')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-domingo"
                    :aria-label="$t('days.sunday')"
                    class="switch-text break-normal both-switch w-40" 
                    v-model="form.domingo.activo" 
                    :active-text="$t('days.sunday')"
                    />
                </div>
                <el-form-item prop="rangoHorasDescarga" class="mb-0">
                  <el-time-picker
                    class="fix-width-single mr-2"
                    :class="{'time-picker-active': form.domingo.activo}"
                    disabled
                    :clearable="false"
                    format="HH:mm"
                    :placeholder="form.domingo.activo 
                      ? form.domingo.range 
                        ? this.defaultInitialHour
                        : this.defaultDisabledMsg 
                      : this.defaultAllDayMsg"
                    >
                  </el-time-picker>
                  <span class="mr-2">-</span>
                  <label>
                    <el-time-picker
                      class="fix-width-single"
                      :class="{'time-picker-active': form.domingo.activo}"
                      :disabled="!form.domingo.activo"
                      :clearable="false"
                      format="HH:mm"
                      v-model="form.domingo.range"
                      :placeholder="form.domingo.activo ? 'Todo el día' : 'Sin descargas'"
                      >
                    </el-time-picker>
                  </label>
                  <base-clear-input-button
                    v-if="form.domingo.range"
                    aria-label="Limpiar hora máxima del domingo"
                    @clear="form.domingo.range = null"
                  />
                </el-form-item>
              </div>
              
            </div>
          </div>
        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <!-- <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/> -->
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_clients')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <!-- <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_clients')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          /> -->
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>los clientes seleccionados. </p>
          </el-popover>
        </template>
      </base-footer>
      <template-link-clients-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkClients" 
        :distributorId="this.id" 
        :dialogOpen="linkToClientsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import { getDownloadScheduleTemplate } from '@/services/distributors/getDownloadScheduleTemplate'
import { updateDownloadScheduleTemplate } from '@/services/distributors/updateDownloadScheduleTemplate'
import { applyDownloadScheduleTemplate } from '@/services/distributors/applyDownloadScheduleTemplate'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkClientsDialog from '@/components/TemplateLinkClientsDialog.vue'

import { i18n } from '@/i18n'

import { getDistributor } from '@/services/distributors/getDistributor'

export default {
  /* eslint-disable camelcase */
  name: 'horario-descarga-template-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkClientsDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      enableEditCampos: true,
      searchView: false,
      linkToClientsDialog: false,
      activeName: 'es',
      header: {
        title: i18n.t('clients.horario_descarga_header_template'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/distributors/details' : 'configurations/clients'
      },
      defaultAllDayMsg: 'Sin descargas',
      defaultDisabledMsg: 'Todo el día por defecto',
      defaultInitialHour: '00:00',
      // checkall: false,
      // valuesCheckbox: {
      //   StoredSpace: false,
      //   NumSMS: false,
      //   NumLocations: false,
      //   NumCompanies: false,
      //   NumeroSedesxCIFEmpresas: false,
      //   NumUsers: false,
      //   daysGroupsCompanies: false,
      //   mailsGroupCompanies: false,
      //   mailsTo: false,
      //   VincularUsuariosGrupoGestorNEOs: false,
      //   mesesUserPass: false,
      // },
      form: {
        activo: false,
        lunes: {
          activo: false,
          range: null,
        },
        martes: {
          activo: false,
          range: null,
        },
        miercoles: {
          activo: false,
          range: null,
        },
        jueves: {
          activo: false,
          range: null,
        },
        viernes: {
          activo: false,
          range: null,
        },
        sabado: {
          activo: false,
          range: null,
        },
        domingo: {
          activo: false,
          range: null,
        },
      },
      rules: {
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkClients () {
      return this.modeTemplate ? 'Aplicar plantilla a clientes' : 'Aplicar campos seleccionados a clientes'
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.lunes.activo': function (value, oldValue) {
      if (!value) this.form.lunes.range = null
    },
    'form.martes.activo': function (value, oldValue) {
      if (!value) this.form.martes.range = null
    },
    'form.miercoles.activo': function (value, oldValue) {
      if (!value) this.form.miercoles.range = null
    },
    'form.jueves.activo': function (value, oldValue) {
      if (!value) this.form.jueves.range = null
    },
    'form.viernes.activo': function (value, oldValue) {
      if (!value) this.form.viernes.range = null
    },
    'form.sabado.activo': function (value, oldValue) {
      if (!value) this.form.sabado.range = null
    },
    'form.domingo.activo': function (value, oldValue) {
      if (!value) this.form.domingo.range = null
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: this.$i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectClients()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template)
    }
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    preSelectClients () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.clients) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.clients)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      // this.valuesCheckbox.StoredSpace = value 
      // this.valuesCheckbox.NumSMS = value 
      // this.valuesCheckbox.NumLocations = value 
      // this.valuesCheckbox.NumCompanies = value
      // this.valuesCheckbox.NumeroSedesxCIFEmpresas = value
      // this.valuesCheckbox.NumUsers = value
      // this.valuesCheckbox.daysGroupsCompanies = value
      // this.valuesCheckbox.mailsGroupCompanies = value
      // this.valuesCheckbox.mailsTo = value
      // this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs = value
      // this.valuesCheckbox.mesesUserPass = value
    },
    toggleDialogLink: function () {
      this.linkToClientsDialog = !this.linkToClientsDialog
    },
    applyLinkHandler: async function (clients) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateClients('ruleForm', clients)
      }
      //  else {
      //   this.UpdateClientsWithSelected('ruleForm', clients)
      // }
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        if (distributor.blnError === true) {
          this.doFeedback(distributor.msgError + ' [Código de error: ' + distributor.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = this.getPayloadFromForm()
          const response = await updateDownloadScheduleTemplate(null, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateClients: function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = this.getPayloadFromForm()
          this.toggleDialogLink()
          const response = await updateDownloadScheduleTemplate(null, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
            const response = await applyDownloadScheduleTemplate({ idDistribuidor: this.id }, clients)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Clientes actualizados correctamente', 'success')
              this.resetControlFormChanges()
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    // UpdateClientsWithSelected: function (formName, clients) {
    //   this.$store.commit('setAjaxRequestPending', true)
    //   this.$store.commit('setIsLoading', true)
    //   this.$refs[formName].validate(async valid => {
    //     if (valid) {
    //       const params = {
    //         idDistribuidor: this.id,
    //         idClientes: clients,

    //         checkNumeroSedes: this.disableTipoLibre ? null : this.valuesCheckbox.NumLocations,
    //         checkNumeroCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumCompanies,
    //         checkNumeroUsuarios: this.disableTipoLibre ? null : this.valuesCheckbox.NumUsers,
    //         checkEspacioTotal: this.disableTipoLibre ? null : this.valuesCheckbox.StoredSpace,
    //         checkNumeroSedesxCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumeroSedesxCIFEmpresas,
    //         checkNumeroSMS: this.disableTipoLibre ? null : this.valuesCheckbox.NumSMS,
    //         checkEnviarMailCopiaOculta: this.valuesCheckbox.mailsTo,
    //         checkEnviarMailGruposNoPropietarios: this.valuesCheckbox.mailsGroupCompanies,
    //         checkGestionarDiasAvisosGrupos: this.valuesCheckbox.daysGroupsCompanies,
    //         checkVincularUsuariosGrupoGestorNEOs: this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs,
    //         checkMesesUserPass: this.valuesCheckbox.mesesUserPass,

    //         NumeroSedes: this.disableTipoLibre ? null :this.form.NumLocations,
    //         NumeroCIFEmpresas: this.disableTipoLibre ? null :this.form.NumCompanies,
    //         NumeroUsuarios: this.disableTipoLibre ? null :this.form.NumUsers,
    //         EspacioTotal: this.disableTipoLibre ? null :this.form.StoredSpace,
    //         NumeroSedesxCIFEmpresas: this.disableTipoLibre ? null :this.form.NumeroSedesxCIFEmpresas,
    //         NumeroSMS: this.disableTipoLibre ? null :this.form.NumSMS,
    //         EnviarMailCopiaOculta: this.form.mailsTo,
    //         EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
    //         GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
    //         VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
    //         MesesUserPass: this.form.mesesUserPass,
    //       }
    //       this.toggleDialogLink()
    //       const response = await applyClientKeys({ idDistribuidor: this.id }, params)
    //       if (response.blnError === true) {
    //         this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
    //       } else {
    //         this.doFeedback('Clientes actualizados correctamente', 'success')
    //       }
    //     } else {
    //       this.doFeedback('Error al procesar los datos, revise la información')
    //     }
    //     this.$store.commit('setIsLoading', false)
    //   })
    // },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
      else this.$router.push({ name: 'configurations/clients' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getDownloadScheduleTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (data) {
      if (data) {
        this.form.activo = data.Activo

        this.form.lunes.activo = data.Horario?.Lunes?.Activo
        this.form.martes.activo = data.Horario?.Martes?.Activo
        this.form.miercoles.activo = data.Horario?.Miercoles?.Activo
        this.form.jueves.activo = data.Horario?.Jueves?.Activo
        this.form.viernes.activo = data.Horario?.Viernes?.Activo
        this.form.sabado.activo = data.Horario?.Sabado?.Activo
        this.form.domingo.activo = data.Horario?.Domingo?.Activo

        if (data.Horario?.Lunes?.HoraFin) {
          this.form.lunes.range = this.generateDateAux(data.Horario?.Lunes.HoraFin)
        } else {
          this.form.lunes.range = null
        }

        if (data.Horario?.Martes?.HoraFin) {
          this.form.martes.range = this.generateDateAux(data.Horario?.Martes.HoraFin)
        } else {
          this.form.martes.range = null
        }

        if (data.Horario?.Miercoles?.HoraFin) {
          this.form.miercoles.range = this.generateDateAux(data.Horario?.Miercoles.HoraFin)
        } else {
          this.form.miercoles.range = null
        }

        if (data.Horario?.Jueves?.HoraFin) {
          this.form.jueves.range = this.generateDateAux(data.Horario?.Jueves.HoraFin)
        } else {
          this.form.jueves.range = null
        }

        if (data.Horario?.Viernes?.HoraFin) {
          this.form.viernes.range = this.generateDateAux(data.Horario?.Viernes.HoraFin)
        } else {
          this.form.viernes.range = null
        }

        if (data.Horario?.Sabado?.HoraFin) {
          this.form.sabado.range = this.generateDateAux(data.Horario?.Sabado.HoraFin)
        } else {
          this.form.sabado.range = null
        }

        if (data.Horario?.Domingo?.HoraFin) {
          this.form.domingo.range = this.generateDateAux(data.Horario?.Domingo.HoraFin)
        } else {
          this.form.domingo.range = null
        }
      }
      this.resetControlFormChanges()
    },
    generateDateAux (dataHora) {
      return new Date(
        new Date().getFullYear(), 
        2, 
        2, 
        dataHora.Horas,
        dataHora.Minutos,
        0,
      )
    },
    getPayloadFromForm () {
      const payload = {
        idDistribuidor: this.id,
        Activo: this.form.activo,
        Horario: {},
      }
      if (this.form.lunes.activo) {
        payload.Horario.Lunes = {}
        payload.Horario.Lunes.Activo = true
        if (this.form.lunes.range) {
          const dateFin = this.form.lunes.range
          payload.Horario.Lunes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.martes.activo) {
        payload.Horario.Martes = {}
        payload.Horario.Martes.Activo = true
        if (this.form.martes.range) {
          const dateFin = this.form.martes.range
          payload.Horario.Martes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.miercoles.activo) {
        payload.Horario.Miercoles = {}
        payload.Horario.Miercoles.Activo = true
        if (this.form.miercoles.range) {
          const dateFin = this.form.miercoles.range
          payload.Horario.Miercoles.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.jueves.activo) {
        payload.Horario.Jueves = {}
        payload.Horario.Jueves.Activo = true
        if (this.form.jueves.range) {
          const dateFin = this.form.jueves.range
          payload.Horario.Jueves.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.viernes.activo) {
        payload.Horario.Viernes = {}
        payload.Horario.Viernes.Activo = true
        if (this.form.viernes.range) {
          const dateFin = this.form.viernes.range
          payload.Horario.Viernes.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      if (this.form.sabado.activo) {
        payload.Horario.Sabado = {}
        payload.Horario.Sabado.Activo = true
        if (this.form.sabado.range) {
          const dateFin = this.form.sabado.range
          payload.Horario.Sabado.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }

      if (this.form.domingo.activo) {
        payload.Horario.Domingo = {}
        payload.Horario.Domingo.Activo = true
        if (this.form.domingo.range) {
          const dateFin = this.form.domingo.range
          payload.Horario.Domingo.HoraFin = {
            Horas: dateFin.getHours(),
            Minutos: dateFin.getMinutes(),
          }
        }
      }
      return payload
    }
  }

}
</script>
